import * as types from './types';

export const deleteSingleTimesheetRequestSuccess = (data) => ({ type: types.DELETE_SINGLE_TIMESHEET_REQUEST_SUCCESS, data });

export const getTimesheetsRequest = (data) => ({ type: types.GET_TIMESHEETS_REQUEST, data });
export const getTimesheetsRequestFailure = (error) => ({ type: types.GET_TIMESHEETS_REQUEST_FAILURE, error });
export const getTimesheetsRequestSuccess = (data) => ({ type: types.GET_TIMESHEETS_REQUEST_SUCCESS, data });
